/**
 * PALETA HÍBRIDA - Mantém identidade + otimiza conversão
 *
 * ESTRATÉGIA:
 * - Cores da marca (verde, azul, roxo) em seções/fundos/títulos
 * - Amarelo APENAS em CTAs (camada de conversão)
 * - Vermelho APENAS em dor
 * - Gradientes mantidos em fundos (não em CTAs)
 */
export var COLORS = {
    // IDENTIDADE VISUAL (mantém da Home)
    brand: {
        green: '#22c55e', // green-500 - sucesso, positivo
        blue: '#3b82f6', // blue-500 - confiança, info
        purple: '#a855f7', // purple-500 - premium, destaque
    },
    // CTA - ÚNICA COR QUENTE (conversão máxima)
    cta: {
        main: '#facc15', // yellow-400 - AÇÃO
        hover: '#fbbf24', // yellow-500
        glow: '#fde047', // yellow-300
        text: '#111827', // gray-900 (texto escuro no amarelo)
    },
    // ALERTA - Apenas para dor
    danger: {
        main: '#ef4444', // red-500
        light: '#f87171', // red-400
        bg: 'rgba(239, 68, 68, 0.1)',
    },
    // BACKGROUNDS (mantém da Home)
    bg: {
        primary: '#111827', // gray-900
        secondary: '#1f2937', // gray-800
        card: '#1f2937', // gray-800
    },
    // TEXTOS
    text: {
        primary: '#ffffff', // white
        secondary: '#e5e7eb', // gray-200
        tertiary: '#9ca3af', // gray-400
    },
    // BORDAS
    border: {
        green: 'rgba(34, 197, 94, 0.3)', // green-500 com 30%
        blue: 'rgba(59, 130, 246, 0.3)', // blue-500 com 30%
        purple: 'rgba(168, 85, 247, 0.3)', // purple-500 com 30%
        neutral: 'rgba(55, 65, 81, 0.5)', // gray-700 com 50%
    },
};
// CLASSES TAILWIND MAPEADAS
export var COLOR_CLASSES = {
    // CTA Principal (AMARELO PURO - conversão)
    ctaPrimary: "\n        bg-yellow-500 \n        text-gray-900 \n        hover:bg-yellow-400 \n        hover:scale-105\n        hover:shadow-[0_0_30px_rgba(250,204,21,0.6)]\n        transition-all \n        duration-300 \n        font-extrabold\n        animate-pulse-slow\n    ",
    // Backgrounds
    bgPrimary: 'bg-gray-900',
    bgSecondary: 'bg-gray-800',
    bgCard: 'bg-gray-800/90',
    // Textos
    textPrimary: 'text-white',
    textSecondary: 'text-gray-200',
    textTertiary: 'text-gray-400',
    // Títulos (mantém identidade)
    headingGreen: 'text-green-500', // Sucesso/positivo
    headingBlue: 'text-blue-500', // Confiança
    headingPurple: 'text-purple-500', // Premium
    headingDanger: 'text-red-500', // Dor
    // Cards com identidade visual (gradientes mantidos)
    cardSuccess: 'bg-gradient-to-br from-green-900/20 to-blue-900/20 border border-green-500/30',
    cardInfo: 'bg-gradient-to-br from-blue-900/20 to-blue-800/20 border border-blue-500/30',
    cardPremium: 'bg-gradient-to-br from-purple-900/20 to-blue-900/20 border border-purple-500/30',
    cardDanger: 'bg-gradient-to-br from-red-900/20 to-red-800/20 border border-red-500/30',
    cardNeutral: 'bg-gray-800/80 border border-gray-700/50',
    // Bordas
    borderGreen: 'border-green-500/30',
    borderBlue: 'border-blue-500/30',
    borderPurple: 'border-purple-500/30',
    borderNeutral: 'border-gray-700/50',
};
// GRADIENTES DE IDENTIDADE (usados em backgrounds de seção)
export var BRAND_GRADIENTS = {
    // Gradiente principal (verde→azul) - mantém da Home
    primary: 'from-green-900/20 via-blue-900/20 to-purple-900/20',
    // Gradiente de sucesso
    success: 'from-green-900/30 to-blue-900/30',
    // Gradiente premium
    premium: 'from-purple-900/30 to-blue-900/30',
    // Gradiente de fundo geral
    bgGeneral: 'from-gray-900 via-gray-800 to-gray-900',
};
// ✅ ADICIONAR NO FINAL DO ARQUIVO:
export var CUSTOM_KEYFRAMES = "\n    @keyframes pulse-slow {\n        0%, 100% {\n            box-shadow: 0 0 0 0 rgba(250, 204, 21, 0.7);\n        }\n        50% {\n            box-shadow: 0 0 0 10px rgba(250, 204, 21, 0);\n        }\n    }\n\n    @keyframes shimmer {\n        0% {\n            background-position: -1000px 0;\n        }\n        100% {\n            background-position: 1000px 0;\n        }\n    }\n\n    .animate-pulse-slow {\n        animation: pulse-slow 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    }\n\n    .animate-shimmer {\n        animation: shimmer 3s linear infinite;\n        background: linear-gradient(\n            to right,\n            transparent 0%,\n            rgba(255, 255, 255, 0.1) 50%,\n            transparent 100%\n        );\n        background-size: 1000px 100%;\n    }\n";
